exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".StartCampaignModal-text-3Hh4E{margin:30px 0;text-align:center}.StartCampaignModal-elligibleTicketDate-2X0-K{text-align:center}.StartCampaignModal-elligibleTicketDate-2X0-K h4{text-transform:uppercase;margin-bottom:30px}", ""]);

// exports
exports.locals = {
	"text": "StartCampaignModal-text-3Hh4E",
	"elligibleTicketDate": "StartCampaignModal-elligibleTicketDate-2X0-K"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/satisfaction/components/StartCampaignModal.less
// module id = 1754
// module chunks = 0